<template>
  <footer class="text-muted">
    <div style="display: flex">
      <div class="container">
        <p><a href="https://merkur-spielewelt.de/datenschutzerklaerung/">Datenschutz</a> & <a href="https://merkur-spielewelt.de/impressum/">Impressum</a></p>
      </div>
      <div style="display:flex">
        <p>Frontend: </p><v-label class="pl-1" :text="this.getAppVersion()"/>
        <p class="pl-2">Backend: </p><v-label class="pl-1 pr-2" :text="this.backendVersion"/>
      </div>
    </div>

  </footer>
</template>

<script>
import MiscService from "@/services/misc.service";

export default {
  name: "custom-footer",
  data() {
    return {
      backendVersion : ""
    }
  },
  methods: {
    getAppVersion() {
      return process.env.VUE_APP_VERSION
    },
    getBackendVersion() {
      MiscService.getBackendVersion().then(response => {
        this.backendVersion = response.data;
      });
    }
  },
  mounted() {
    this.getBackendVersion();
  }
}
</script>

<style scoped>
a{
  color: var(--merkur-bg-color);
}

.container{
  position: sticky !important;
  left: 0;
  margin-left: 0;
}
</style>